var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "title": "지원하기",
      "fullscreen": "",
      "persistent": "",
      "width": "1080",
      "maxWidth": "95%",
      "needsLogin": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    userType: _vm.userType
  }, false), [_c('v-layout', {
    staticClass: "bottom-sheet__contents",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_vm.shows ? _c('application-form-card', _vm._b({
    on: {
      "close": function close($event) {
        _vm.shows = false;
      }
    }
  }, 'application-form-card', {
    _recruitment: _vm._recruitment,
    recruitmentSubject: _vm.recruitmentSubject
  }, false)) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }